<template>
  <div>
    <h1>Recomendadas</h1>
    <div v-if="loading">
      <div style="">Loading...</div>
    </div>
    <div v-else>
      <div style="display: flex; flex-wrap: wrap; justify-content: left">
        <MoviePoster v-for="item in items" :key="item.tmdb_id" :item="item" @click="selectedId = item.tmdb_id" />
      </div>
    </div>

    <!-- movie details in bottom sheet -->
    <v-bottom-sheet :value="selectedId" scrollable fullscreen>
      <v-card>
        <v-card-title>
          <v-btn icon @click="selectedId = ''">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <MovieDetailPage :tmdb_id="selectedId" />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import api from '@/assets/api'
import MoviePoster from './MoviePoster.vue'
import MovieDetailPage from './v2/MovieDetailPage.vue'
export default {
  components: {
    MoviePoster,
    MovieDetailPage,
  },
  data() {
    return {
      items: [],
      loading: false,
      selectedId: '',
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      let x = await api.apiFetch('/watchlistt/movies')
      this.loading = false
      if (x.ok) {
        let j = await x.json()
        //sort j by updatedAt
        j.sort((a, b) => {
          return new Date(b.updatedAt) - new Date(a.updatedAt)
        })
        j = j.filter((item) => {
          return item.engagement && item.engagement.recommended && item.engagement.recommended.length
        })
        this.items = j
      } else {
        alert('Error fetching movies...')
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
